// Container imports
const { SHOW, HIDE } = require('./actions')
const ConfirmModalRecord = require('./record')

function confirmModalReducer(state, { type, payload }) {
  switch (type) {
    case SHOW:
      return ConfirmModalRecord.fromJS(payload)
    case HIDE:
      return null
    default:
      return state
  }
}

module.exports = confirmModalReducer
